import MultipleUpload from './MultipleUpload'

export default MultipleUpload
